import z from 'zod';
const stageCountsSchema = z.looseObject({
    done: z.number(),
    processing: z.number(),
    error: z.number(),
    skip: z.number(),
    pending: z.number(),
});
export const projectProgressWebhookSchema = z.looseObject({
    type: z.literal('project-progress'),
    projectId: z.string(),
    correlationId: z.string().optional(),
    generatedAt: z.string(),
    totalPages: z.number(),
    totalDocuments: z.number(),
    // Intentionally looser than ProjectPageProcessing['stages'] (plain string
    // record): new stages (e.g. reconstruction) must validate without a schema
    // release. The hand-written type below is the authoritative wire contract.
    stages: z.record(z.string(), stageCountsSchema),
});
//# sourceMappingURL=project-progress.webhook.js.map